define([
    "./nlgProgressBarModule",
    "./nlgProgressBarDirective"
], function () {
});
